module.exports = __webpack_public_path__ + "static/media/Intruded tooth 12.e85f61c5.png";